import type { ILayoutBound } from "../Strategy/Strategy.interface";

class StrategyBounds {
  static getBounds(props: ILayoutBound) {
    const containerWidth = props.container.width;
    const containerHeight = props.container.height;
    const left = (props.bound.left / 100) * containerWidth;
    const width = (props.bound.width / 100) * containerWidth;
    const top = (props.bound.top / 100) * containerHeight;
    const height = (props.bound.height / 100) * containerHeight;

    return {
      left,
      width,
      top,
      height,
    };
  }

  /** @deprecated Use StrategyBounds.getBounds() directly (static) */
  getBounds(props: ILayoutBound) {
    return StrategyBounds.getBounds(props);
  }
}

export default StrategyBounds;
